import { TabbedModuleSettings as DevelopSettings } from 'Deer/components/TabbedModuleSettings/TabbedModuleSettings';

export default DevelopSettings;
